import { createContext, useContext, useEffect, useState } from "react";
import { Get } from "../Utils/Helpers";
import { FetchResponse } from "../Utils/Types";

interface IRegisterContext {
	loggedIn: boolean;
	setLoggedIn: React.Dispatch<React.SetStateAction<boolean>>;
	cuil: string;
	setCuil: React.Dispatch<React.SetStateAction<string>>;
	cuilValido: boolean;
	setCuilValido: React.Dispatch<React.SetStateAction<boolean>>;
	mail: string;
	setMail: React.Dispatch<React.SetStateAction<string>>;
	registrado: boolean;
	setRegistrado: React.Dispatch<React.SetStateAction<boolean>>;
	registrandose: boolean;
	setRegistrandose: React.Dispatch<React.SetStateAction<boolean>>;
}

export const RegisterContext = createContext({} as IRegisterContext);
export const useRegisterContext = () => useContext(RegisterContext);

const Provider = ({ children }) => {
	const [loggedIn, setLoggedIn] = useState(false);
	const [registrado, setRegistrado] = useState(false);
	const [cuil, setCuil] = useState("");
	const [mail, setMail] = useState("");
	const [cuilValido, setCuilValido] = useState(false);
	const [registrandose, setRegistrandose] = useState(false);

	useEffect(() => {
		if (!loggedIn) {
			setCuil("");
			setMail("");
		}
	}, [loggedIn]);

	useEffect(() => {
		let disposed = false;

		const _valido = cuil.replaceAll("_", "").length === 13;

		setCuilValido(_valido);

		if (_valido) {
			(async () => {
				if (disposed) return;

				const result: FetchResponse = await Get(`/Registrado/${cuil}`);

				setRegistrado(result.resultados);
			})();
		}

		return () => {
			disposed = true;
		};
	}, [cuil]);

	const value = {
		loggedIn,
		setLoggedIn,
		cuil,
		setCuil,
		cuilValido,
		setCuilValido,
		mail,
		setMail,
		registrado,
		setRegistrado,
		registrandose,
		setRegistrandose,
	};

	return <RegisterContext.Provider value={value}>{children}</RegisterContext.Provider>;
};

const obj = {
	Provider,
	Consumer: RegisterContext.Consumer,
};

export default obj;
